import { TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

/**
 * Igual que `titlecase`, pero deja intactos los tokens que contienen un punto
 * (siglas tipo "S.I.I.") — `titlecase` los convertiría en "S.i.i.".
 *
 * Se usa en la barra superior del layout para el nombre de módulo que publican
 * los componentes vía `NavbarService.setModulo()`. El resto de los módulos
 * siguen mandando texto en MAYÚSCULAS ("COMPRA/Reportes") y se ven igual que
 * antes.
 */
@Pipe({
    name: 'moduleTitle',
    standalone: true,
})
export class ModuleTitlePipe implements PipeTransform {
    private readonly _titleCase = new TitleCasePipe();

    /** Siglas sin punto que deben quedar en mayúsculas (no se pueden deducir:
     *  el resto de los módulos también llegan en MAYÚSCULAS). */
    private static readonly SIGLAS = new Set(['BNI']);

    transform(value: string | null | undefined): string {
        if (!value) {
            return '';
        }
        return value
            .split(' ')
            .map((token) => {
                if (token.includes('.')) return token;
                const upper = token.toUpperCase();
                return ModuleTitlePipe.SIGLAS.has(upper) ? upper : this._titleCase.transform(token);
            })
            .join(' ');
    }
}
